import React from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import { ButtonLink } from "core/Typography";

import FlipVertical from "core/ReusableIcons/FlipVertical";
import FlipHorizontal from "core/ReusableIcons/FlipHorizontal";

import { useIconEditorDispatch } from "js/contexts/IconEditorContext";

const EditorFlip = ({ axis, iconId }) => {
    const dispatch = useIconEditorDispatch();

    const flipIcon = () => {
        let actionType;

        if (axis === "x") actionType = "FLIP_X";
        if (axis === "y") actionType = "FLIP_Y";

        dispatch({
            type: actionType,
            iconId
        });
    };

    const getTooltipText = () => {
        if (axis === "y") return "Flip Vertical";
        if (axis === "x") return "Flip Horizontal";
    };

    // TODO: move to helpers.js file

    return (
        <Tooltip message={getTooltipText()} size="small">
            <ButtonLink onClick={() => flipIcon()}>
                {axis === "y" && <FlipVertical />}
                {axis === "x" && <FlipHorizontal />}
            </ButtonLink>
        </Tooltip>
    );
};

EditorFlip.propTypes = {
    dispatch: PropTypes.func,
    direction: PropTypes.oneOf(["x", "y"]),
    iconId: PropTypes.string
};

export default EditorFlip;
